import vInputSearch from './InputSearch.vue';

export { vInputSearch };



// WEBPACK FOOTER //
// ./src/baseComponents/components/InputSearch/index.js